import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Chat from '../components/Chat';
import './ChatPage.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

const ChatPage: React.FC = () => {
  const navigate = useNavigate();
  useAuth(); // Auth context for authentication state
  const [collections, setCollections] = useState<string[]>([]);
  const [selectedCollection, setSelectedCollection] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    fetchCollections();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchCollections = async () => {
    try {
      const response = await fetch(`${API_URL}/collections`);
      const data = await response.json();
      const collectionNames = data.collections || [];
      setCollections(collectionNames);
      if (collectionNames.length > 0 && !selectedCollection) {
        const preferred = collectionNames.find((c: string) => c === 'saucy_hr_docs');
        setSelectedCollection(preferred || collectionNames[0]);
      }
    } catch (error) {
      console.error('Error fetching collections:', error);
    } finally {
      setLoading(false);
    }
  };

  const getCollectionDisplayName = (collection: string) => {
    return collection
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  return (
    <div className="chat-page">
      {loading ? (
        <div className="loading">
          <div className="loading-spinner"></div>
          <p>Loading collections...</p>
        </div>
      ) : (
        <div className="chat-wrapper">
          <div className="chat-header-bar">
            <div className="chat-header-left">
              <button className="back-button" onClick={() => navigate('/dashboard')} aria-label="Back to dashboard">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M19 12H5M12 19l-7-7 7-7"/>
                </svg>
              </button>
              <div className="chat-header-info">
                <div className="chat-avatar">📚</div>
                <div className="chat-header-text">
                  <h2>Prepwise Assistant</h2>
                  <span className="chat-status">Online</span>
                </div>
              </div>
            </div>
            <div className="chat-header-right">
              {collections.length > 0 && (
                <select
                  className="collection-selector"
                  value={selectedCollection}
                  onChange={(e) => setSelectedCollection(e.target.value)}
                >
                  {collections.map((collection) => (
                    <option key={collection} value={collection}>
                      {getCollectionDisplayName(collection)}
                    </option>
                  ))}
                </select>
              )}
              <button className="header-menu-button" aria-label="Menu">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="1"/>
                  <circle cx="19" cy="12" r="1"/>
                  <circle cx="5" cy="12" r="1"/>
                </svg>
              </button>
            </div>
          </div>
          <Chat collectionName={selectedCollection} />
        </div>
      )}
    </div>
  );
};

export default ChatPage;
